module.exports = __webpack_public_path__ + "img/1095138637.2a70e5da.jpg";